import { Button } from "@devhop/ui";
import { useNavigate, useSearch } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";
import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { useChecklistExecutionHistoryQuery } from "../api/queries";
import { ChecklistExecutionHistoryFilter } from "../ui/ChecklistExecutionHistoryFilter";
import { ChecklistExecutionHistoryTable } from "../ui/ChecklistExecutionHistoryTable";

export function ChecklistExecutionHistoryPage() {
  const nav = useNavigate({ from: "/app/checklists/execution-history" });
  const search = useSearch({ from: "/app/checklists/execution-history" });

  const limit = search.limit ?? 20;
  const offset = search.offset ?? 0;

  const list = useChecklistExecutionHistoryQuery({
    limit,
    offset,
    checklistId: search.checklistId,
    departmentId: search.departmentId,
    userId: search.userId,
  });

  return (
    <>
      <Header />
      <Main>
        <div className="mb-4 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
          <div>
            <h1 className="font-bold text-2xl tracking-tight">
              ປະຫວັດການບັນທຶກ Checklist
            </h1>
            <p className="mt-1 text-muted-foreground">
              ລາຍການການເຮັດ Checklist ຕາມຜະແນກັບຜູ້ບັນທຶກ — ກອງຕາມ Checklist, ພະແນກ
              (ຂອງ Checklist) ແລະພະນັກງານ
            </p>
          </div>
          <Button
            variant="outline"
            onClick={() => nav({ to: "/app/checklists" })}
          >
            <ArrowLeft className="mr-2 h-4 w-4" />
            ກັບລາຍການ Checklist
          </Button>
        </div>

        <div className="flex flex-col rounded-xl border bg-card pt-2">
          <ChecklistExecutionHistoryFilter />
          <ChecklistExecutionHistoryTable
            data={list.data?.data ?? []}
            isLoading={list.isLoading}
            offset={offset}
            limit={limit}
            totalCount={list.data?.meta.total ?? 0}
            onPaginationChange={(nextOffset, nextLimit) =>
              nav({
                search: {
                  ...search,
                  offset: nextOffset,
                  limit: nextLimit,
                },
              })
            }
          />
        </div>
      </Main>
    </>
  );
}
